<ion-header class="header">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item *ngFor="let breadcrumb of breadcrumbs" class="breadcrumb__item" [routerLink]="[breadcrumb.link]" detail="false">
          <span [innerHTML]="breadcrumb.name"></span> <span>/</span>
        </ion-item>
      </ion-list>
    </ion-buttons>
    <ion-title class="--logo">
      <a class="header__logo" [routerLink]="['/']">
        <app-logo></app-logo>
      </a>
      <span>Meine Webseite</span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-avatar class="header__avatar">
        <img
          class="header__avatar__image"
          [src]="avatarImagePath"
          alt="{{ (user$ | async)?.firstName + ' ' + (user$ | async)?.lastName }}"
        />
      </ion-avatar>
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="web-builder__content">
  <iframe #webBuilder class="web-builder__content__iframe" [src]="iframeSrc" (load)="iframeLoaded($event)"></iframe>
</ion-content>
